import { type HTMLAttributes } from "react"
import { cn } from "cn"

function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-2xl bg-foreground/10", className)}
      {...props}
    />
  )
}

export { Skeleton }
